import React, {useState, useEffect} from 'react';
import { useParams } from 'react-router';
import {useHistory} from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { device } from '../device';
import { marked } from 'marked';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const StyledTypography = styled(Typography)(({theme}) => `
    hyphens: auto;
    word-wrap: break-word; /* Older syntax */
    overflow-wrap: break-word; /* Modern syntax */
`);

const Section = styled(Box)(({theme}) => `
    margin: 32px 16px;

    @media ${device.mobileL} {
        margin: 32px 16px;
    }
    @media ${device.tablet} {
        margin: 64px 16px;
    }
    @media ${device.laptop} {
        margin: 64px 16px;
    }
`);

const ContentBox = styled(Box)(({theme}) => `
    display: flex;
    flex-direction: column;
    gap: 32px;
    position: relative;
    width: 100%;
    @media ${device.tablet} {
        flex-direction: row;
    }
    @media ${device.laptop} {
        justify-content: center;
    }
`);

const TextsBox = styled(Box)(({theme}) => `
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media ${device.tablet} {
        align-items: center;
        flex: 1;
        text-align: left;
    }
    @media ${device.laptop} {
        max-width: 480px;
    }
`);

const TitleBox = styled(Box)(({theme}) => `
    @media ${device.mobileL} {
        max-width: 393px;
    }
    @media ${device.tablet} {
        max-width: 100%;
        min-width: 100%;
        text-align: left;
    }
    @media ${device.laptop} {
    }
`);

const DescriptionBox = styled(Box)(({theme}) => `
    @media ${device.mobileL} {
        max-width: 393px;
        margin-bottom: 32px;
    }
    @media ${device.tablet} {
        max-width: 100%;
        min-width: 100%;
    }
`);

const ImageSection = styled(Box)(({theme}) => `
    position: relative;
    min-width: 100%;
    
    @media ${device.mobileL} {
        display: flex;
        justify-content: center;
    }
    @media ${device.tablet} {
        flex: 1;
        min-width: unset;
    }
    @media ${device.laptop} {
        max-width: 480px;
    }
`);

const Image = styled('img')(({ theme }) => `
    width: 100%;
    object-fit: cover;

    @media ${device.mobileL} {
        max-width: 393px;
        margin-bottom: 32px;
    }
    @media ${device.tablet} {
        max-width: 100%;
    }
`);

const Example = styled(Box)(({theme}) => `

`);

const ButtonBox = styled(Box)(({theme}) => `

`);

const ButtonLink = styled(Button)(({theme, dialog}) => `
    display: ${dialog ? 'none' : 'flex'};
`);

const ButtonDialog = styled(Button)(({theme, dialog}) => `
    display: ${dialog ? 'flex' : 'none'};
`);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function OrganizationIntroduction (props){

    let itemImages = props['images-1'];

    const htmlContent_text1 = props['text-1'] && marked(props['text-1']);
    const htmlContent_text2 = props['text-2'] && marked(props['text-2']);
    const htmlContent_text3 = props['text-3'] && marked(props['text-3']);
    const htmlContent_text4 = props['text-4'] && marked(props['text-4']);
    const htmlContent_text5 = props['text-5'] && marked(props['text-5']);

    const dialog = Boolean(props["layout-variant-activated"] && props["layout-variant-activated"]);

    function handleClick(inputUrl){
        if(inputUrl.substring(0,7) === 'http://'){
            inputUrl = 'https://' + inputUrl.substring(7);
        } else if(inputUrl.substring(0,8) !== 'https://'){
            inputUrl = 'https://' + inputUrl;
        }

        window.open(inputUrl, '_blank', 'noopener,noreferrer');
    }

    //dialog actions start
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    //dialog actions end
    //dialog content start
    function renderItem(){
        
        let itemTexts = props['text-5'].split('/!/');

        let itemObjs = [];

        for(let i = 0; i < itemTexts.length; i++){
            let itemObj = {
                text: String
            }
            itemObj.text = itemTexts[i];
            itemObjs.push(itemObj);
        }

        return (
            <DialogContent>
                <DialogContentText>
                    {
                        Array.isArray(itemObjs) && itemObjs.length > 0 && itemObjs?.map((el, index) => {
                            let elIndex = index;
                            return (
                                <Box key={index}>
                                    {
                                        itemTexts &&
                                        <Typography 
                                            variant='body1'
                                            dangerouslySetInnerHTML={{ __html: marked(el.text) }}
                                        />
                                    }
                                </Box>
                            )
                        })
                    }
                </DialogContentText>
            </DialogContent>
        )
    }
    //dialod content end

    return(

        <Section>
            <ContentBox>
                <TextsBox>
                    {   props['text-1'] &&
                        <TitleBox>
                            <StyledTypography 
                                variant='h3'
                                dangerouslySetInnerHTML={{ __html: htmlContent_text1 }}
                            />
                        </TitleBox>
                    }
                    {   props['text-2'] &&
                        <DescriptionBox>
                            <Typography 
                                variant='body1' 
                                dangerouslySetInnerHTML={{ __html: htmlContent_text2 }}
                            />
                        </DescriptionBox>
                    }
                    {   props['text-3'] &&
                        <ButtonBox> 
                            <ButtonLink
                                dialog={dialog}
                                variant='contained'
                                className='btn btn-success'
                                size='large'
                                onClick={() => handleClick(props['url-1'])}
                            >
                                {
                                    props['text-3']
                                }
                            </ButtonLink>
                            <ButtonDialog
                                dialog={dialog}
                                variant='contained'
                                className='btn btn-success'
                                size='large'
                                onClick={handleClickOpen}
                            >
                                {
                                    props['text-3']
                                }
                            </ButtonDialog>
                            {console.log(dialog)}
                        </ButtonBox>
                    }
                </TextsBox>
                {   itemImages &&
                    <ImageSection>
                        <Image 
                            src={`${itemImages[0].thumbnails.large.url}`}
                            srcSet={`${itemImages[0].thumbnails.large.url}`}
                            alt={props['text-1'] && props['text-1']}
                            loading="lazy"
                        />
                    </ImageSection>
                }
            </ContentBox>
            <Dialog
                open={open}
                slots={{
                transition: Transition,
                }}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
                role="alertdialog"
            >
                {   props['text-3'] &&
                    <DialogTitle>
                        <Typography 
                            variant='body1'
                            dangerouslySetInnerHTML={{ __html: htmlContent_text4 }}
                        />
                    </DialogTitle>
                }
                <DialogContent>
                    {
                        props['text-5'] &&
                        renderItem()
                    }
                </DialogContent>
                {/* <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        Disagree
                    </Button>
                    <Button onClick={handleClose}>Agree</Button>
                </DialogActions> */}
            </Dialog>
        </Section>

    )

}